var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6531 0.315968C15.1156 0.742467 15.1156 1.43397 14.6531 1.86043L8.33734 7.68513C7.87486 8.11164 7.12517 8.11164 6.6627 7.68513L0.346844 1.86043C-0.115615 1.43397 -0.115615 0.742467 0.346844 0.315968C0.809304 -0.110531 1.55912 -0.110531 2.02158 0.315968L7.50002 5.36835L12.9785 0.315968C13.441 -0.110531 14.1907 -0.110531 14.6531 0.315968Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.9c31d0a5f7d3eca1083b6d88fe922505.svg";
export { ForwardRef as ReactComponent };